import { TimelineSegmentId, TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '@Scatt';
import CefrScoreSegmentData from './CefrScoreSegmentData.js'

class CefrScoreChangeHistoryData extends TimelineSegmentContentDataBase {
  constructor(cefrScoreTimelineSegmentId = undefined, cefrScoreSegment = undefined, date = new Date()) {
    super();
    this.cefrScoreTimelineSegmentId = cefrScoreTimelineSegmentId;
    this.cefrScoreSegment = cefrScoreSegment;
    this.date = date;
  }

  static generateFromRawObj(cefrScoreChangeHistoryDataRawObj) {
    return new this(
      TimelineSegmentId.generateFromRawObj(cefrScoreChangeHistoryDataRawObj['cefr_score_timeline_segment_id']),
      CefrScoreSegmentData.generateFromRawObj(
        cefrScoreChangeHistoryDataRawObj['cefr_score_segment']['begin'],
        cefrScoreChangeHistoryDataRawObj['cefr_score_segment']['end'],
        cefrScoreChangeHistoryDataRawObj['cefr_score_segment']['data'],
      ),
      new Date(cefrScoreChangeHistoryDataRawObj['date']),
    );
  }

  generateRawObj() {
    let cefrScoreChangeHistoryDataRawObj = {};
    cefrScoreChangeHistoryDataRawObj['cefr_score_timeline_segment_id'] = this.cefrScoreTimelineSegmentId.mergedId;
    cefrScoreChangeHistoryDataRawObj['cefr_score_segment'] = this.cefrScoreSegment.generateRawObj();
    cefrScoreChangeHistoryDataRawObj['date'] = this.date.toISOString();
    return cefrScoreChangeHistoryDataRawObj;
  }

  toString() {
    return '';
  }

  clone() {
    return new CefrScoreChangeHistoryData(
      this.cefrScoreTimelineSegmentId.clone(),
      this.cefrScoreSegment.clone(),
      new Date(this.date.getTime()),
    );
  }

  isSameAs(that) {
    if (!this.cefrScoreTimelineSegmentId.isSameAs(that.cefrScoreTimelineSegmentId)) return false;
    if (!this.cefrScoreSegment.isSameAs(that.cefrScoreSegment)) return false;
    if (this.date.getTime() !== that.date.getTime()) return false;
    return true;
  }
}

class CefrScoreChangeHistorySegmentData extends TimelineSegmentDataBase {
  static contentData = CefrScoreChangeHistoryData;

  constructor(begin, end, cefrScoreChangeHistoryData, isLocked) {
    super(begin, end, cefrScoreChangeHistoryData, isLocked);
  }

  static toString() {
    return 'CefrScoreChangeHistorySegmentData';
  }

  static get name() {
    return 'CEFR Score Change History Data';
  }

  clone() {
    return new CefrScoreChangeHistorySegmentData(this.begin, this.end, this.data.clone(), false);
  }
}

export default CefrScoreChangeHistorySegmentData;
